import { jsxs as t, jsx as l } from "react/jsx-runtime";
function e() {
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 40 40",
      width: "37.3543px",
      height: "37.3542px",
      children: [
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "clip105", children: /* @__PURE__ */ l(
          "path",
          {
            d: "m 412,437.32812 h 75.97266 V 513 H 412 Z m 0,0",
            id: "path1806"
          }
        ) }) }),
        /* @__PURE__ */ t(
          "g",
          {
            id: "layer1",
            transform: "matrix(1.400650978088379, 0, 0, 1.400650978088379, -126.81981658935547, -157.19244384765625)",
            children: [
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#28215c",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 117.64174,129.27975 c 0.001,0.005 0.001,0.01 0.001,0.0152 l 0.0648,-0.0537 c -0.022,0.0138 -0.0441,0.0262 -0.0661,0.0386",
                  id: "path8454"
                }
              ),
              /* @__PURE__ */ t(
                "g",
                {
                  transform: "matrix(0.3527778,0,0,0.3527778,-54.006707,-41.022345)",
                  style: { clipRule: "nonzero" },
                  clipPath: "url(#clip105)",
                  id: "g8460",
                  children: [
                    /* @__PURE__ */ l(
                      "path",
                      {
                        style: {
                          fill: "#ffffff",
                          fillOpacity: "1",
                          fillRule: "nonzero",
                          stroke: "none"
                        },
                        d: "m 485.9375,437.48828 0.0273,-0.11719 0.0156,-0.0273 c 0,0.0117 0.0234,-0.0117 0.0351,0.0742 -0.0273,0.0742 -0.0586,0.0703 -0.0742,0.0703 -0.004,0 -0.004,0 -0.004,0 z m 0.0312,-0.13672 0.008,-0.0117 z m 1.41016,0.60156 c -0.36719,-0.38281 -0.87891,-0.625 -1.44141,-0.625 h -71.52344 c -0.5625,0 -1.07422,0.24219 -1.4414,0.625 -0.36719,0.38282 -0.59375,0.91016 -0.59375,1.49219 v 71.36719 c 0,0.58203 0.22656,1.10937 0.59375,1.49219 0.36718,0.38281 0.8789,0.62109 1.44531,0.62109 h 71.51953 c 0.5625,0 1.07422,-0.23828 1.44141,-0.62109 0.35156,-0.36719 0.57421,-0.86328 0.59375,-1.41407 h 0.004 v -71.44531 c 0,-0.58203 -0.23047,-1.10937 -0.59765,-1.49219",
                        id: "path8456"
                      }
                    ),
                    /* @__PURE__ */ l(
                      "path",
                      {
                        style: {
                          fill: "#286199",
                          fillOpacity: "1",
                          fillRule: "nonzero",
                          stroke: "none"
                        },
                        d: "m 485.96875,437.34766 0.004,-0.008 z m -0.0312,0.14062 c 0,0 0,0 0.004,0 0.0156,0 0.0469,0.004 0.0742,-0.0703 -0.008,-0.0859 -0.0351,-0.0625 -0.0351,-0.0742 l -0.0156,0.0273 z m -72.08984,0.0937 c 0.17187,-0.0586 0.35937,-0.0898 0.55078,-0.0898 -0.19141,0 -0.37891,0.0312 -0.55078,0.0898 m -0.64454,0.59375 c -0.30859,0.32422 -0.5039,0.77344 -0.5039,1.26953 v 71.36328 c 0,0.5 0.19531,0.94922 0.5039,1.27344 0.3125,0.32422 0.73829,0.52344 1.21485,0.52344 h 71.51953 c 0.47266,0 0.89844,-0.19922 1.21094,-0.52344 0.3125,-0.32422 0.5039,-0.77344 0.5039,-1.27344 v -71.36328 c 0,-0.49609 -0.1914,-0.94531 -0.5039,-1.26953 -0.3125,-0.32812 -0.73828,-0.52344 -1.21094,-0.52344 h -71.51953 c -0.47656,0 -0.90235,0.19532 -1.21485,0.52344 m 1.21485,74.75 c -0.56641,0 -1.07813,-0.23828 -1.44531,-0.62109 -0.36719,-0.38282 -0.59375,-0.91407 -0.59375,-1.4961 v -71.36328 c 0,-0.58203 0.22656,-1.10937 0.59375,-1.49219 0.36718,-0.38281 0.8789,-0.625 1.44531,-0.625 h 71.51953 c 0.5625,0 1.07422,0.24219 1.44141,0.625 0.36718,0.38282 0.59375,0.91016 0.59375,1.49219 v 71.44531 c -0.0195,0.55079 -0.24219,1.04688 -0.59375,1.41407 -0.36719,0.38281 -0.87891,0.62109 -1.44141,0.62109 z m 0,0",
                        id: "path8458"
                      }
                    ),
                    /* @__PURE__ */ l(
                      "path",
                      {
                        d: "M 485.649 437.348 L 485.653 437.34 L 485.649 437.348 Z M 485.619 437.488 C 485.619 437.488 485.619 437.488 485.623 437.488 C 485.639 437.488 485.669 437.492 485.696 437.418 C 485.688 437.332 485.661 437.355 485.661 437.344 L 485.646 437.371 L 485.619 437.488 Z M 414.209 437.582 C 414.379 437.523 414.566 437.492 414.755 437.492 C 414.566 437.492 414.379 437.523 414.209 437.582 M 413.571 438.176 C 413.265 438.5 413.072 438.949 413.072 439.445 L 413.072 510.809 C 413.072 511.309 413.265 511.758 413.571 512.082 C 413.881 512.406 414.302 512.605 414.773 512.605 L 485.619 512.605 C 486.089 512.605 486.508 512.406 486.818 512.082 C 487.128 511.758 487.317 511.309 487.317 510.809 L 487.317 439.445 C 487.317 438.949 487.128 438.5 486.818 438.176 C 486.508 437.848 486.089 437.652 485.619 437.652 L 414.773 437.652 C 414.302 437.652 413.881 437.848 413.571 438.176 M 414.773 512.926 C 414.214 512.926 413.706 512.687 413.342 512.305 C 412.979 511.922 412.754 511.391 412.754 510.809 L 412.754 439.445 C 412.754 438.863 412.979 438.336 413.342 437.953 C 413.706 437.57 414.214 437.328 414.773 437.328 L 485.619 437.328 C 486.176 437.328 486.683 437.57 487.046 437.953 C 487.411 438.336 487.635 438.863 487.635 439.445 L 487.635 510.891 C 487.615 511.441 487.394 511.937 487.046 512.305 C 486.683 512.687 486.176 512.926 485.619 512.926 L 414.773 512.926 Z M 414.773 512.926",
                        id: "path8458",
                        style: {
                          fill: "rgb(40, 97, 153)",
                          fillOpacity: "1",
                          fillRule: "nonzero",
                          strokeWidth: "0.607142px",
                          stroke: "rgb(40, 97, 153)"
                        }
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#4fa630",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 96.723113,136.72942 -0.35553,1.14929 h -0.39136 l -0.23427,-0.77446 -0.23013,0.77446 h -0.3955 l -0.35277,-1.14929 h 0.38585 l 0.19706,0.79238 0.24529,-0.79238 h 0.32659 l 0.23289,0.79238 0.1943,-0.79238 z m 0,0",
                  id: "path8462"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#4fa630",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 98.775013,136.72942 -0.35553,1.14929 h -0.39136 l -0.23427,-0.77446 -0.23013,0.77446 h -0.3955 l -0.35278,-1.14929 h 0.38585 l 0.19707,0.79238 0.24529,-0.79238 h 0.32659 l 0.23289,0.79238 0.1943,-0.79238 z m 0,0",
                  id: "path8464"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#4fa630",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 100.82692,136.72942 -0.35554,1.14929 h -0.38998 l -0.234267,-0.77446 -0.23151,0.77446 h -0.3955 l -0.35278,-1.14929 h 0.38585 l 0.19844,0.79238 0.24392,-0.79238 h 0.326587 l 0.23289,0.79238 0.1943,-0.79238 z m 0,0",
                  id: "path8466"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#4fa630",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 101.4429,137.87871 h -0.38172 v -0.40239 h 0.38172 z m 0,0",
                  id: "path8468"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#4fa630",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 102.57013,137.15662 c -0.003,-0.0772 -0.0221,-0.13505 -0.0579,-0.17364 -0.0358,-0.0386 -0.0923,-0.0593 -0.16812,-0.0593 -0.0717,0 -0.12953,0.0193 -0.17501,0.0551 -0.0455,0.0372 -0.0717,0.0965 -0.0772,0.17777 z m 0.36518,0.21635 h -0.84198 c 0.005,0.0896 0.0386,0.15847 0.10197,0.20671 0.0634,0.0469 0.15572,0.0703 0.27975,0.0703 0.0772,0 0.15296,-0.0138 0.226,-0.0413 0.073,-0.0275 0.12953,-0.0579 0.17225,-0.0896 h 0.0413 v 0.2949 c -0.0841,0.0331 -0.16261,0.0579 -0.23564,0.073 -0.073,0.0152 -0.15572,0.0221 -0.24392,0.0221 -0.23151,0 -0.4079,-0.051 -0.53054,-0.15572 -0.12265,-0.10335 -0.18466,-0.2508 -0.18466,-0.44235 0,-0.19017 0.0593,-0.339 0.17501,-0.45062 0.11576,-0.11162 0.27561,-0.16674 0.47818,-0.16674 0.18741,0 0.32797,0.0482 0.42168,0.14193 0.0937,0.0951 0.14056,0.23014 0.14056,0.4079 z m 0,0",
                  id: "path8470"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#4fa630",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 103.79383,137.90903 c -0.1006,0 -0.19155,-0.011 -0.27423,-0.0358 -0.0827,-0.0234 -0.15572,-0.0606 -0.21635,-0.11025 -0.0606,-0.0496 -0.10749,-0.113 -0.14194,-0.18741 -0.0331,-0.0758 -0.0496,-0.16537 -0.0496,-0.26596 0,-0.10749 0.0179,-0.19982 0.0537,-0.27837 0.0358,-0.0772 0.0854,-0.14193 0.15021,-0.19292 0.062,-0.0482 0.13367,-0.0841 0.21497,-0.10611 0.0813,-0.0234 0.16537,-0.0344 0.25218,-0.0344 0.0786,0 0.15021,0.01 0.21635,0.0262 0.0661,0.0165 0.12816,0.0386 0.18604,0.0661 v 0.31419 h -0.0524 c -0.0138,-0.0124 -0.0317,-0.0262 -0.051,-0.0427 -0.0207,-0.0165 -0.0455,-0.0331 -0.0744,-0.0482 -0.0276,-0.0152 -0.0593,-0.0275 -0.0923,-0.0372 -0.0331,-0.01 -0.0717,-0.0152 -0.11575,-0.0152 -0.0992,0 -0.17364,0.0317 -0.22738,0.0937 -0.0524,0.062 -0.0786,0.14745 -0.0786,0.25493 0,0.11025 0.0275,0.19431 0.0813,0.25081 0.0537,0.0579 0.13091,0.0868 0.23013,0.0868 0.0469,0 0.0882,-0.005 0.1254,-0.0165 0.0372,-0.011 0.0675,-0.0234 0.0923,-0.0372 0.0234,-0.0138 0.0441,-0.0289 0.0606,-0.0427 0.0179,-0.0152 0.0344,-0.0303 0.0496,-0.0441 h 0.0524 v 0.31419 c -0.0579,0.0262 -0.11851,0.0482 -0.1819,0.0648 -0.0634,0.0152 -0.13229,0.0234 -0.20946,0.0234",
                  id: "path8472"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#4fa630",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 105.14982,137.58381 c 0.0234,-0.0289 0.0413,-0.0648 0.0538,-0.10611 0.011,-0.0413 0.0179,-0.0978 0.0179,-0.17088 0,-0.0675 -0.007,-0.12402 -0.0193,-0.1695 -0.0124,-0.0455 -0.0289,-0.0827 -0.051,-0.11024 -0.0221,-0.0275 -0.0482,-0.0468 -0.0786,-0.0593 -0.0303,-0.011 -0.0634,-0.0165 -0.0992,-0.0165 -0.0358,0 -0.0661,0.004 -0.0951,0.0138 -0.0276,0.01 -0.0537,0.0289 -0.0786,0.0579 -0.0234,0.0262 -0.04,0.0634 -0.0538,0.10887 -0.0138,0.0469 -0.0193,0.10473 -0.0193,0.17501 0,0.0634 0.005,0.11713 0.0165,0.16261 0.0124,0.0469 0.0289,0.0841 0.051,0.11162 0.022,0.0262 0.0482,0.0455 0.0785,0.0579 0.0303,0.0124 0.0648,0.0193 0.10335,0.0193 0.0344,0 0.0661,-0.006 0.0965,-0.0179 0.0303,-0.011 0.0551,-0.0303 0.0772,-0.0565 m 0.45338,-0.27975 c 0,0.19017 -0.0551,0.339 -0.16537,0.44787 -0.11024,0.10748 -0.26458,0.16261 -0.4644,0.16261 -0.19844,0 -0.35278,-0.0551 -0.46439,-0.16261 -0.10887,-0.10887 -0.16399,-0.2577 -0.16399,-0.44787 0,-0.18879 0.0551,-0.33899 0.16536,-0.44786 0.11162,-0.10749 0.26596,-0.16261 0.46302,-0.16261 0.2012,0 0.35554,0.0551 0.4644,0.16399 0.11025,0.10887 0.16537,0.25907 0.16537,0.44648",
                  id: "path8474"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#4fa630",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 106.23571,137.87871 h -0.36931 v -1.59164 h 0.36931 z m 0,0",
                  id: "path8476"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#4fa630",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 107.27889,137.5783 v -0.2384 c -0.051,0.004 -0.10473,0.01 -0.16261,0.0165 -0.0579,0.007 -0.10197,0.0152 -0.13091,0.0248 -0.0372,0.0124 -0.0661,0.0289 -0.0854,0.051 -0.0193,0.0221 -0.0289,0.051 -0.0289,0.0868 0,0.0234 0.003,0.0427 0.005,0.0579 0.006,0.0152 0.0152,0.0289 0.0317,0.0427 0.0152,0.0138 0.0344,0.0234 0.0565,0.0303 0.0221,0.007 0.0551,0.01 0.10197,0.01 0.0372,0 0.0744,-0.007 0.11162,-0.0221 0.0386,-0.0152 0.0717,-0.0345 0.1006,-0.0593 m 0,0.17914 c -0.0207,0.0152 -0.0455,0.0331 -0.0744,0.0538 -0.0289,0.0207 -0.0565,0.0386 -0.0827,0.0496 -0.0358,0.0165 -0.073,0.0289 -0.113,0.0372 -0.0386,0.008 -0.0813,0.011 -0.12678,0.011 -0.11024,0 -0.20119,-0.0331 -0.27423,-0.1006 -0.0744,-0.0675 -0.11162,-0.15434 -0.11162,-0.25907 0,-0.0841 0.0193,-0.15296 0.0565,-0.20532 0.0386,-0.0537 0.091,-0.0951 0.15985,-0.12541 0.0689,-0.0317 0.15296,-0.0537 0.25356,-0.0661 0.1006,-0.0124 0.20533,-0.0221 0.31419,-0.0289 v -0.006 c 0,-0.0634 -0.0262,-0.10748 -0.0786,-0.13229 -0.051,-0.0234 -0.12678,-0.0358 -0.22875,-0.0358 -0.0606,0 -0.1254,0.011 -0.1943,0.0317 -0.0689,0.0221 -0.11714,0.0386 -0.14883,0.0496 h -0.0331 v -0.27699 c 0.0386,-0.01 0.10197,-0.022 0.19017,-0.0358 0.0868,-0.0138 0.17501,-0.0221 0.2632,-0.0221 0.20946,0 0.36105,0.0331 0.45338,0.0978 0.0937,0.0634 0.13918,0.16537 0.13918,0.30317 v 0.78135 h -0.3638 z m 0,0",
                  id: "path8478"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#4fa630",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 108.80162,137.2958 c 0,-0.10197 -0.0179,-0.18052 -0.0524,-0.23565 -0.0345,-0.0551 -0.0965,-0.0827 -0.18603,-0.0827 -0.0344,0 -0.0703,0.005 -0.10611,0.0165 -0.0372,0.01 -0.073,0.0248 -0.10611,0.0441 v 0.57602 c 0.0262,0.01 0.0524,0.0165 0.0758,0.0207 0.0234,0.003 0.0524,0.004 0.0854,0.004 0.0978,0 0.1695,-0.0276 0.21773,-0.0854 0.0482,-0.0565 0.0717,-0.14331 0.0717,-0.25769 m 0.37896,-0.007 c 0,0.18052 -0.0496,0.32797 -0.14883,0.44097 -0.1006,0.11438 -0.22462,0.17088 -0.37345,0.17088 -0.0648,0 -0.12126,-0.007 -0.1695,-0.0207 -0.0482,-0.0124 -0.0937,-0.0331 -0.1378,-0.0593 l -0.0152,0.0579 h -0.35415 v -1.59164 h 0.36931 v 0.56224 c 0.0565,-0.0441 0.11438,-0.0813 0.17363,-0.10886 0.0593,-0.0275 0.12678,-0.0427 0.20395,-0.0427 0.1447,0 0.25632,0.0524 0.33486,0.15709 0.0786,0.10473 0.11714,0.24943 0.11714,0.43408",
                  id: "path8480"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#4fa630",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 110.21273,137.15662 c -0.003,-0.0772 -0.022,-0.13505 -0.0579,-0.17364 -0.0358,-0.0386 -0.0923,-0.0593 -0.1695,-0.0593 -0.0703,0 -0.12815,0.0193 -0.175,0.0551 -0.0455,0.0372 -0.0703,0.0965 -0.0758,0.17777 z m 0.36518,0.21635 h -0.84335 c 0.007,0.0896 0.04,0.15847 0.10335,0.20671 0.0634,0.0469 0.15571,0.0703 0.27836,0.0703 0.0786,0 0.15434,-0.0138 0.22738,-0.0413 0.073,-0.0275 0.12953,-0.0579 0.17225,-0.0896 h 0.0413 v 0.2949 c -0.0841,0.0331 -0.16261,0.0579 -0.23564,0.073 -0.0744,0.0152 -0.15572,0.0221 -0.24529,0.0221 -0.23014,0 -0.40653,-0.051 -0.52917,-0.15572 -0.12265,-0.10335 -0.18466,-0.2508 -0.18466,-0.44235 0,-0.19017 0.0592,-0.339 0.17501,-0.45062 0.11576,-0.11162 0.27561,-0.16674 0.47818,-0.16674 0.18741,0 0.32798,0.0482 0.42168,0.14193 0.0937,0.0951 0.14056,0.23014 0.14056,0.4079 z m 0,0",
                  id: "path8482"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#4fa630",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 111.20768,137.87871 h -0.36932 v -1.59164 h 0.36932 z m 0,0",
                  id: "path8484"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#4fa630",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 111.95044,137.87871 h -0.38309 v -0.40239 h 0.38309 z m 0,0",
                  id: "path8486"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#4fa630",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 113.0763,137.15662 c -0.003,-0.0772 -0.0207,-0.13505 -0.0565,-0.17364 -0.0372,-0.0386 -0.0937,-0.0593 -0.1695,-0.0593 -0.0717,0 -0.12954,0.0193 -0.17502,0.0551 -0.0455,0.0372 -0.0717,0.0965 -0.0772,0.17777 z m 0.36655,0.21635 h -0.84335 c 0.005,0.0896 0.04,0.15847 0.10335,0.20671 0.062,0.0469 0.15572,0.0703 0.27836,0.0703 0.0772,0 0.15297,-0.0138 0.226,-0.0413 0.073,-0.0275 0.13091,-0.0579 0.17226,-0.0896 h 0.0413 v 0.2949 c -0.0827,0.0331 -0.16124,0.0579 -0.23565,0.073 -0.073,0.0152 -0.15434,0.0221 -0.24391,0.0221 -0.23013,0 -0.40652,-0.051 -0.53055,-0.15572 -0.12264,-0.10335 -0.18328,-0.2508 -0.18328,-0.44235 0,-0.19017 0.0579,-0.339 0.17502,-0.45062 0.11575,-0.11162 0.27422,-0.16674 0.4768,-0.16674 0.18741,0 0.32797,0.0482 0.42168,0.14193 0.0951,0.0951 0.14193,0.23014 0.14193,0.4079 z m 0,0",
                  id: "path8488"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#4fa630",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 114.84707,137.87871 h -0.36931 v -0.12678 c -0.0689,0.051 -0.13091,0.091 -0.18741,0.11851 -0.0565,0.0262 -0.12402,0.04 -0.2012,0.04 -0.12678,0 -0.22462,-0.0372 -0.29352,-0.10886 -0.0689,-0.073 -0.10197,-0.18053 -0.10197,-0.32384 v -0.74828 h 0.36931 v 0.57051 c 0,0.0579 10e-4,0.10611 0.005,0.14469 0.003,0.0386 0.0124,0.0703 0.0262,0.0951 0.0124,0.0262 0.0317,0.0441 0.0579,0.0551 0.0262,0.0124 0.0634,0.0179 0.11025,0.0179 0.0317,0 0.0661,-0.006 0.10473,-0.0179 0.0386,-0.011 0.0744,-0.0289 0.11024,-0.051 v -0.81442 h 0.36931 z m 0,0",
                  id: "path8490"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#286199",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 96.016183,135.63251 v -6.64077 h 1.86036 v 0.52641 h -1.34221 v 2.79328 h 0.81579 v 0.52641 h -0.81579 v 2.26826 h 1.34221 v 0.52641 z m 0,0",
                  id: "path8492"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#286199",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 99.837483,132.60909 v -0.75516 c 0,-0.11438 -0.04,-0.20947 -0.11989,-0.28939 -0.0799,-0.0799 -0.17638,-0.11851 -0.29076,-0.11851 -0.11576,0 -0.21222,0.0386 -0.29215,0.11851 -0.0813,0.0799 -0.11989,0.17501 -0.11989,0.28939 v 2.90352 c 0,0.11438 0.0386,0.20947 0.11989,0.28939 0.0799,0.0799 0.17639,0.11851 0.29215,0.11851 0.11438,0 0.21084,-0.0386 0.29076,-0.11851 0.0799,-0.0799 0.11989,-0.17501 0.11989,-0.28939 v -0.69591 h 0.518137 v 0.69591 c 0,0.13092 -0.0234,0.25218 -0.0717,0.36518 -0.0482,0.11438 -0.11437,0.21222 -0.19843,0.29766 -0.0841,0.0854 -0.183277,0.15158 -0.296277,0.19981 -0.113,0.0482 -0.23289,0.0717 -0.36242,0.0717 -0.13092,0 -0.25219,-0.0234 -0.3638,-0.0717 -0.11301,-0.0482 -0.21223,-0.11437 -0.29629,-0.19981 -0.0854,-0.0854 -0.15158,-0.18328 -0.19843,-0.29766 -0.0482,-0.113 -0.073,-0.23426 -0.073,-0.36518 v -2.90352 c 0,-0.13092 0.0248,-0.25219 0.073,-0.36519 0.0469,-0.11437 0.113,-0.21359 0.19843,-0.29765 0.0841,-0.0854 0.18328,-0.15159 0.29629,-0.19981 0.11161,-0.0482 0.23288,-0.0717 0.3638,-0.0717 0.12953,0 0.24942,0.0234 0.36242,0.0717 0.113,0.0482 0.212217,0.11437 0.296277,0.19981 0.0841,0.0841 0.15021,0.18328 0.19843,0.29765 0.0482,0.113 0.0717,0.23427 0.0717,0.36519 v 0.75516 z m 0,0",
                  id: "path8494"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#286199",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 102.45438,131.85393 c 0,-0.11438 -0.0413,-0.20947 -0.12127,-0.28939 -0.0799,-0.0786 -0.17639,-0.11851 -0.29077,-0.11851 -0.11437,0 -0.21221,0.04 -0.29214,0.11851 -0.0799,0.0799 -0.11989,0.17501 -0.11989,0.28939 v 2.9049 c 0,0.113 0.04,0.20946 0.11989,0.28801 0.0799,0.0799 0.17777,0.11851 0.29214,0.11851 0.11438,0 0.21085,-0.0386 0.29077,-0.11851 0.0799,-0.0786 0.12127,-0.17501 0.12127,-0.28801 z m 0.51676,2.9049 c 0,0.12954 -0.0234,0.2508 -0.0717,0.3638 -0.0469,0.11438 -0.113,0.2136 -0.19844,0.29766 -0.0841,0.0854 -0.18328,0.15158 -0.2949,0.19981 -0.113,0.0482 -0.23426,0.0717 -0.3638,0.0717 -0.12954,0 -0.2508,-0.0234 -0.3638,-0.0717 -0.113,-0.0482 -0.21222,-0.11437 -0.29628,-0.19981 -0.0841,-0.0841 -0.15021,-0.18328 -0.19844,-0.29766 -0.0482,-0.113 -0.0717,-0.23426 -0.0717,-0.3638 v -2.9049 c 0,-0.13092 0.0234,-0.25219 0.0717,-0.36519 0.0482,-0.11437 0.11438,-0.21221 0.19844,-0.29765 0.0841,-0.0854 0.18328,-0.15159 0.29628,-0.19981 0.113,-0.0482 0.23426,-0.0717 0.3638,-0.0717 0.12954,0 0.2508,0.0234 0.3638,0.0717 0.11162,0.0482 0.21084,0.11437 0.2949,0.19981 0.0854,0.0854 0.15158,0.18328 0.19844,0.29765 0.0482,0.113 0.0717,0.23427 0.0717,0.36519 z m 0,0",
                  id: "path8496"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#286199",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 104.24583,135.63251 h -0.51815 v -6.6325 h 0.51815 z m 0,0",
                  id: "path8498"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#286199",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 105.52051,134.75745 c 0,0.11438 0.0386,0.20947 0.11989,0.28939 0.0799,0.0799 0.17639,0.11851 0.29077,0.11851 0.11575,0 0.21222,-0.0386 0.29214,-0.11851 0.0799,-0.0799 0.11989,-0.17501 0.11989,-0.28939 v -1.39182 c 0,-0.113 -0.04,-0.20946 -0.11989,-0.28939 -0.0799,-0.0785 -0.17639,-0.11851 -0.29214,-0.11851 -0.11438,0 -0.21084,0.04 -0.29077,0.11851 -0.0813,0.0799 -0.11989,0.17639 -0.11989,0.28939 z m 0.82269,0.84199 c -0.062,0.0276 -0.1254,0.051 -0.19017,0.0675 -0.0661,0.0165 -0.1378,0.0248 -0.21773,0.0248 -0.12953,0 -0.2508,-0.0234 -0.36518,-0.0717 -0.113,-0.0482 -0.21222,-0.11438 -0.29628,-0.19982 -0.0854,-0.0854 -0.15158,-0.18328 -0.19981,-0.29766 -0.0482,-0.113 -0.073,-0.23426 -0.073,-0.36518 v -1.39182 c 0,-0.13091 0.0248,-0.25218 0.073,-0.36518 0.0482,-0.11299 0.11438,-0.21359 0.19981,-0.29765 0.0841,-0.0854 0.18328,-0.15159 0.29628,-0.19982 0.11438,-0.0482 0.23565,-0.0717 0.36518,-0.0717 0.0799,0 0.15572,0.01 0.226,0.0289 0.0703,0.0207 0.13091,0.0413 0.1819,0.0634 v -0.66972 c 0,-0.11438 -0.04,-0.20947 -0.11989,-0.28939 -0.0799,-0.0785 -0.17639,-0.11851 -0.29214,-0.11851 -0.11438,0 -0.21084,0.04 -0.29077,0.11851 -0.0813,0.0799 -0.11989,0.17501 -0.11989,0.28939 v 0.22875 h -0.51952 v -0.22875 c 0,-0.13092 0.0248,-0.25219 0.073,-0.36519 0.0482,-0.11437 0.113,-0.21359 0.19844,-0.29765 0.0841,-0.0854 0.18328,-0.15159 0.29628,-0.19982 0.113,-0.0482 0.23289,-0.0717 0.36242,-0.0717 0.12954,0 0.2508,0.0234 0.3638,0.0717 0.113,0.0482 0.21222,0.11438 0.29628,0.19982 0.0841,0.0841 0.15021,0.18328 0.19844,0.29765 0.0482,0.113 0.0717,0.23427 0.0717,0.36519 v 3.77858 h -0.51814 z m 0,0",
                  id: "path8500"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#286199",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 108.83883,131.56454 c -0.0799,-0.0786 -0.17639,-0.11851 -0.29077,-0.11851 -0.11437,0 -0.21222,0.04 -0.29214,0.11851 -0.0799,0.0799 -0.11989,0.17639 -0.11989,0.28939 v 2.90352 c 0,0.11438 0.04,0.20947 0.11989,0.28939 0.0799,0.0799 0.17777,0.11851 0.29214,0.11851 0.11438,0 0.21084,-0.0386 0.29077,-0.11851 0.0799,-0.0799 0.12126,-0.17501 0.12126,-0.28939 v -2.90352 c 0,-0.113 -0.0413,-0.20947 -0.12126,-0.28939 m -0.5209,-0.61599 c 0.0703,-0.0193 0.14607,-0.0289 0.226,-0.0289 0.12953,0 0.2508,0.0234 0.36518,0.0717 0.113,0.0482 0.21222,0.11438 0.29628,0.19982 0.0854,0.0841 0.15158,0.18328 0.19981,0.29765 0.0482,0.113 0.073,0.23427 0.073,0.36519 v 2.90352 c 0,0.13091 -0.0248,0.25218 -0.073,0.36518 -0.0482,0.11438 -0.11438,0.21222 -0.19981,0.29766 -0.0841,0.0854 -0.18328,0.15158 -0.29628,0.19981 -0.11438,0.0482 -0.23565,0.073 -0.36518,0.073 -0.0799,0 -0.15159,-0.01 -0.21773,-0.0262 -0.0648,-0.0165 -0.12816,-0.04 -0.19017,-0.0675 v 0.0331 h -0.51814 v -6.6325 h 0.51814 v 2.01194 c 0.051,-0.022 0.11162,-0.0427 0.1819,-0.0634",
                  id: "path8502"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#286199",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 110.75154,133.12723 h 0.82407 v -1.2733 c 0,-0.113 -0.04,-0.20947 -0.11989,-0.28939 -0.0813,-0.0786 -0.17776,-0.11851 -0.29214,-0.11851 -0.11438,0 -0.21222,0.04 -0.29215,0.11851 -0.0799,0.0799 -0.11989,0.17639 -0.11989,0.28939 z m -0.51814,-1.2733 c 0,-0.13092 0.0234,-0.25219 0.0717,-0.36656 0.0482,-0.11162 0.11438,-0.21084 0.19844,-0.29628 0.0854,-0.0854 0.18328,-0.15159 0.29628,-0.19981 0.113,-0.0482 0.23427,-0.0717 0.3638,-0.0717 0.12954,0 0.25081,0.0234 0.36381,0.0717 0.11299,0.0482 0.21083,0.11437 0.29627,0.19981 0.0841,0.0854 0.15021,0.18466 0.19844,0.29628 0.0469,0.11437 0.0717,0.23564 0.0717,0.36656 v 1.79971 h -1.34221 v 1.10381 c 0,0.11438 0.04,0.20947 0.11989,0.28939 0.0799,0.0799 0.17776,0.11851 0.29214,0.11851 0.11438,0 0.21084,-0.0386 0.29215,-0.11851 0.0799,-0.0799 0.11989,-0.17501 0.11989,-0.28939 v -0.34726 h 0.51814 v 0.34726 c 0,0.13092 -0.0248,0.25218 -0.0717,0.36656 -0.0482,0.113 -0.11438,0.21222 -0.19844,0.29628 -0.0854,0.0854 -0.18328,0.15158 -0.29627,0.19981 -0.113,0.0482 -0.23427,0.0717 -0.36381,0.0717 -0.12953,0 -0.2508,-0.0234 -0.3638,-0.0717 -0.113,-0.0482 -0.21084,-0.11437 -0.29628,-0.19981 -0.0841,-0.0841 -0.15021,-0.18328 -0.19844,-0.29628 -0.0482,-0.11438 -0.0717,-0.23564 -0.0717,-0.36656 z m 0,0",
                  id: "path8504"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#286199",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 113.36706,135.63251 h -0.51676 v -6.6325 h 0.51676 z m 0,0",
                  id: "path8506"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#4fa630",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 97.567853,128.70511 h -1.52135 v -2.30959 h 1.52135 v 0.27285 h -1.21405 v 0.63389 h 1.21405 v 0.27286 h -1.21405 v 0.85714 h 1.21405 z m 0,0",
                  id: "path8508"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#4fa630",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 99.794763,127.77769 c 0,0.16812 -0.0179,0.31419 -0.0551,0.43822 -0.0372,0.1254 -0.0965,0.22875 -0.18052,0.31143 -0.0799,0.0785 -0.17363,0.13643 -0.27974,0.17226 -0.10611,0.0358 -0.23014,0.0537 -0.37207,0.0537 -0.1447,0 -0.27148,-0.0193 -0.37896,-0.0565 -0.10749,-0.0386 -0.19844,-0.0951 -0.27148,-0.1695 -0.0841,-0.0854 -0.14331,-0.18742 -0.18052,-0.30731 -0.0372,-0.11989 -0.0551,-0.26734 -0.0551,-0.44235 v -1.38217 h 0.3073 v 1.39733 c 0,0.1254 0.008,0.22462 0.0248,0.29628 0.0179,0.073 0.0469,0.13918 0.0868,0.19844 0.0455,0.0662 0.10749,0.11713 0.18466,0.15158 0.0786,0.0331 0.17226,0.051 0.2825,0.051 0.11024,0 0.20533,-0.0165 0.2825,-0.051 0.0772,-0.033 0.13918,-0.0841 0.18603,-0.15158 0.04,-0.0593 0.0689,-0.12678 0.0854,-0.20258 0.0179,-0.0772 0.0262,-0.17087 0.0262,-0.28387 v -1.4056 h 0.30731 z m 0,0",
                  id: "path8510"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#4fa630",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 106.90268,117.74144 c -0.0689,-0.0372 -0.13918,-0.0703 -0.21359,-0.0992 -0.87505,-0.33487 -1.85484,0.10197 -2.18971,0.97565 -0.33623,0.87367 0.1006,1.85346 0.97428,2.1897 0.0744,0.0289 0.14883,0.051 0.22462,0.0689 0.12127,0.0276 0.22324,-0.0468 0.25218,-0.16812 0.0276,-0.12264 -0.0275,-0.24942 -0.14883,-0.27836 -0.0551,-0.0124 -0.11024,-0.0289 -0.16398,-0.0496 -0.565,-0.21773 -0.87919,-0.80478 -0.77308,-1.37942 l 0.9095,0.34727 c 0.11576,0.0455 0.22738,-0.0138 0.27285,-0.13091 0.0441,-0.11714 0.005,-0.24667 -0.11024,-0.29215 l -0.90813,-0.34864 c 0.30455,-0.49748 0.93156,-0.72347 1.49655,-0.50712 0.0537,0.022 0.11025,0.0427 0.15986,0.0703 0.10886,0.0606 0.22737,0.0165 0.288,-0.0937 0.0593,-0.11024 0.0386,-0.24391 -0.0703,-0.30454",
                  id: "path8512"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#4fa630",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 104.77775,124.87416 c -0.0579,1.36426 -0.55259,1.03904 -0.48231,3.41616 -0.21498,-1.45934 0.0165,-1.65778 0.35002,-2.94762 -0.37759,1.15617 -0.56913,1.06935 -0.4203,2.99034 -0.0951,0.10335 0.0234,0.51401 -0.34451,0.32659 -0.30317,-0.50436 -0.29215,-1.32705 0.50987,-4.2664 0.0276,-0.12265 0.4203,-0.32935 0.38723,0.48093",
                  id: "path8514"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#4fa630",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 101.20036,126.45064 c 0.23013,0 0.96739,-0.0978 1.41663,0.21635 0.28249,0.19844 0.52778,0.37345 0.60358,0.49196 0.0661,0.10335 0.10335,0.226 0.1502,0.3197 0.0469,0.0951 -0.32797,0.0951 -0.52779,0.0951 -0.29352,0 -1.15617,-1.1231 -1.64262,-1.1231",
                  id: "path8516"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#4fa630",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 103.49342,126.18605 c 0.0951,0.1695 0.0758,0.37759 -0.12265,0.2825 -0.24804,-0.11713 -0.63252,-0.2825 -0.81166,-0.39549 -0.96601,-0.61048 -2.30132,-3.54845 -3.651797,-3.8971 0.24529,-0.01 0.42443,-0.0193 0.62287,0.0193 0.24116,0.0455 3.784087,1.91547 3.963237,3.9908",
                  id: "path8518"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#4fa630",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 105.30554,126.55399 c -0.73587,-1.00046 1.42489,-2.39641 3.7648,-1.47174 -0.26321,0.0193 -0.74414,-0.01 -0.98943,0.113 0.0744,0.11299 0.59393,0.15158 1.06522,0.18878 -0.1502,-0.0841 -0.2067,-0.13091 -0.339,-0.1502 0.75517,-0.0854 1.1989,0.37758 1.6881,0.5085 -0.25356,0.0193 -0.42444,0.0193 -0.4892,0.0193 0.008,0.0386 0.0275,0.0289 0.0744,0.0854 -0.25494,-0.10473 -1.16031,-0.0386 -1.48139,0.0469 -0.32109,0.0854 -0.51815,0.01 -0.72623,0.0193 0.0372,0.0469 0.0854,0.0565 0.113,0.10335 -0.34865,-0.0854 -1.13275,-0.0193 -1.67018,0.24529 0.0469,-0.0565 0.0937,-0.10335 0.1502,-0.13229 -0.49058,0.113 -1.01837,0.50988 -1.16031,0.42444",
                  id: "path8520"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#4fa630",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 104.94725,127.52688 c 0,-0.31143 0.64217,-0.42443 0.88746,-0.48093 0.24529,-0.0579 0.76343,-0.21084 1.19751,-0.21773 0.58567,-0.01 1.54754,0.15158 1.983,0.50988 -0.20809,-0.0758 -0.69867,-0.22738 -0.9536,-0.19844 0.0661,0.0469 0.0758,0.0661 0.0854,0.0951 0,0 -0.18053,0 -0.26459,0.0744 0.0661,-0.0193 0.43408,0.0193 0.59393,0.0289 -0.17914,0.0372 -0.75516,0.13229 -0.8778,0.1695 0.0758,0.0289 0.11299,0.0469 0.15985,0.0758 -0.41479,0.0372 -1.37666,0.50023 -1.77354,0.50987 -0.39549,0.01 -1.03766,-0.0193 -1.03766,-0.56637",
                  id: "path8522"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#286199",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 106.26603,115.30644 0.37069,-0.26871 h -0.45888 l -0.14194,-0.43547 -0.14056,0.43547 h -0.45889 l 0.37069,0.26871 -0.14193,0.43684 0.37069,-0.2701 0.37069,0.2701 z m 0,0",
                  id: "path8524"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#286199",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 108.34136,115.83561 0.37069,-0.26872 h -0.45751 l -0.14194,-0.43684 -0.14193,0.43684 h -0.45752 l 0.3707,0.26872 -0.14194,0.43546 0.37069,-0.26872 0.37069,0.26872 z m 0,0",
                  id: "path8526"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#286199",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 109.79519,117.40244 0.37069,-0.2701 h -0.45889 l -0.14056,-0.43546 -0.14193,0.43546 h -0.45889 l 0.37069,0.2701 -0.14056,0.43546 0.37069,-0.26872 0.36932,0.26872 z m 0,0",
                  id: "path8528"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#286199",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 104.18795,115.83561 0.37069,-0.26872 h -0.45751 l -0.14194,-0.43684 -0.14193,0.43684 h -0.45751 l 0.37069,0.26872 -0.14194,0.43546 0.37069,-0.26872 0.3707,0.26872 z m 0,0",
                  id: "path8530"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#286199",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 102.7355,117.40244 0.37069,-0.2701 h -0.45889 l -0.14194,-0.43546 -0.14056,0.43546 h -0.45888 l 0.37069,0.2701 -0.14194,0.43546 0.37069,-0.2701 0.3707,0.2701 z m 0,0",
                  id: "path8532"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#286199",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 110.30506,119.36476 0.37069,-0.26871 h -0.45889 l -0.14193,-0.43684 -0.14056,0.43684 h -0.45889 l 0.37069,0.26871 -0.14193,0.43547 0.37069,-0.26872 0.37069,0.26872 z m 0,0",
                  id: "path8534"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#286199",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 109.73731,121.40564 0.37069,-0.26872 h -0.45751 l -0.14194,-0.43546 -0.14193,0.43546 h -0.45751 l 0.37069,0.26872 -0.14194,0.43546 0.37069,-0.26872 0.3707,0.26872 z m 0,0",
                  id: "path8536"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#286199",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 108.23662,122.87049 0.36932,-0.26871 h -0.45751 l -0.14194,-0.43546 -0.14056,0.43546 h -0.45888 l 0.37069,0.26871 -0.14194,0.43546 0.37069,-0.26871 0.3707,0.26871 z m 0,0",
                  id: "path8538"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#286199",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 102.792,121.40564 0.37069,-0.26872 h -0.45751 l -0.14194,-0.43546 -0.14194,0.43546 h -0.45751 l 0.3707,0.26872 -0.14194,0.43546 0.37069,-0.26872 0.37069,0.26872 z m 0,0",
                  id: "path8540"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#286199",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 104.29406,122.87049 0.37069,-0.26871 h -0.45889 l -0.14193,-0.43684 -0.14056,0.43684 h -0.45751 l 0.36931,0.26871 -0.14056,0.43546 0.37069,-0.26871 0.3707,0.26871 z m 0,0",
                  id: "path8542"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#286199",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 102.22562,119.36476 0.37069,-0.26871 h -0.45888 l -0.14194,-0.43684 -0.14056,0.43684 h -0.45751 l 0.36932,0.26871 -0.14056,0.43547 0.37069,-0.26872 0.37069,0.26872 z m 0,0",
                  id: "path8544"
                }
              ),
              /* @__PURE__ */ l(
                "path",
                {
                  style: {
                    fill: "#286199",
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none",
                    strokeWidth: "0.35277778"
                  },
                  d: "m 106.26603,123.46581 0.37069,-0.26872 h -0.45888 l -0.14194,-0.43546 -0.14056,0.43546 h -0.45889 l 0.37069,0.26872 -0.14193,0.43546 0.37069,-0.26872 0.37069,0.26872 z m 0,0",
                  id: "path8546"
                }
              )
            ]
          }
        )
      ]
    }
  );
}
export {
  e as default
};
